export default __webpack_public_path__ + "static/media/django.694aa762.png";